import React, { useState } from 'react';
import useStyles from './styles'

function TextInput({label, type, onInput, onChange, onBlur, name, value, id, containerStyle, inputStyle, disabled, className, startFocused}) {
  const classes = useStyles();
  const [val, setVal] = useState("")
  return (
    <label className={classes.label} style={containerStyle || {}}>
      <span>{label}</span>
      <input autoFocus={startFocused} style={inputStyle || {}} id={id || ""} value={value || val} name={name || ""} type={type || "text"} 
      onInput={(e) => {
        setVal(e.target.value);
        if (onInput) {
          onInput(e.target.value);
        }
      }} 
      onChange={e => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
      disabled={disabled || false}
      onBlur={onBlur && onBlur}
      className={classes.input + " " + className}></input>
    </label>
  );
}

export default TextInput;